import React, { useState } from 'react';
import { Meteor } from 'meteor/meteor';
import { forEach, keyBy, map, set } from 'lodash';
import PropTypes from 'prop-types';
import { Roles } from 'meteor/alanning:roles';
import {
  LAYER_SUBTYPES,
  LAYER_TYPES,
  LAYER_TYPES_FREE,
  FREE_SUBTYPES
} from '../../../api/Layers/Layers';

import LayersList from '../../components/LayersList';
import LoadingIpsilum from '../../components/LoadingIpsilum';

const { defaultMapCenter } = Meteor.settings.public;

const INITIAL_DATE_RANGE_START = '2020-01-01';
const INITIAL_DATE_RANGE_END = new Date().toISOString().slice(0, 10);
const INITIAL_BOUNDING_BOX = [
  [-180, -90],
  [180, 90]
];

const Layers = props => {
  const { loading } = props;
  if (!loading) {
    const [timeFilterOn, changeTimeFilterOn] = useState(false);
    const [dateRangeStart, changeRangeStart] = useState(INITIAL_DATE_RANGE_START);
    const [dateRangeEnd, changeRangeEnd] = useState(INITIAL_DATE_RANGE_END);
    const [locationFilterOn, changeLocationFilterOn] = useState(false);
    const [boundingBox, changeBoundingBox] = useState(INITIAL_BOUNDING_BOX);
    const userId = Meteor.userId();
    const timeFilterProps = {
      changeFilterOn: changeTimeFilterOn,
      changeRangeEnd,
      changeRangeStart,
      dateRangeEnd,
      dateRangeStart,
      filterOn: timeFilterOn,
      humanValue: 'Date',
      name: 'date'
    };

    const locationFilterProps = {
      boundingBox,
      changeBoundingBox,
      changeFilterOn: changeLocationFilterOn,
      defaultLocation: defaultMapCenter,
      filterOn: locationFilterOn,
      humanValue: 'Location',
      name: 'location'
    };

    const allFilters = keyBy(
      map(
        [...map(LAYER_TYPES.properties), ...map(LAYER_SUBTYPES.properties)],
        ({ name, value, humanValue }) => ({
          filterOn: false,
          name: `type${name}`,
          value,
          humanValue
        })
      ),
      'name'
    );
    const freeFilters = keyBy(
      map(
        [
          ...map(LAYER_TYPES_FREE.properties),
          ...map(FREE_SUBTYPES, (value, key) => {
            return LAYER_SUBTYPES.properties[key];
          })
        ],
        ({ name, value, humanValue }) => ({
          filterOn: false,
          name: `type${name}`,
          value,
          humanValue
        })
      ),
      'name'
    );
    const isFree = Roles.userIsInRole(userId, ['free-user']);
    const typeFilters = isFree ? freeFilters : allFilters;
    const typeFilterProps = { ...typeFilters };
    forEach(typeFilters, ({ name }) => {
      const [filterOn, changeFilterOn] = useState(false);
      set(typeFilterProps, `${name}.filterOn`, filterOn);
      set(typeFilterProps, `${name}.changeFilterOn`, changeFilterOn);
    });

    const tagsFilterProps = {
      name: 'tags',
      tagsInFilter: []
    };

    const filterOptions = {
      tags: tagsFilterProps,
      time: timeFilterProps,
      location: locationFilterProps,
      ...typeFilterProps
    };

    return <LayersList filterOptions={filterOptions} {...props} />;
  }
  return <LoadingIpsilum />;
};

Layers.defaultProps = {};

Layers.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default Layers;
